export default __webpack_public_path__ + "e2bc88a16ab12438ae05046ad260555f.png";